var _ArrowUp;
import React, { useCallback } from "react";
import cn from "clsx";
import ArrowUp from "@crehana/compass.icons.outline/ArrowUp";
import { useMediaQuery } from "@crehana/react-hooks";
import { Tooltip } from "@crehana/ui";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ActionButton = function ActionButton(_ref) {
  var isDark = _ref.isDark,
    metric = _ref.metric,
    className = _ref.className;
  var _useMediaQuery = useMediaQuery('md'),
    isMd = _useMediaQuery.matches;
  var renderArrow = useCallback(function (classNames) {
    return /*#__PURE__*/_jsx("div", {
      className: cn('tw-flex tw-items-center tw-justify-center tw-ml-auto tw-rounded-0.4',
      // Sizes
      'tw-w-2 tw-h-2 sm:tw-w-2.4 sm:tw-h-2.4',
      // Position
      'tw-absolute tw-right-0 tw-top-0 sm:tw-relative', 'dark:tw-bg-neutral-dark-700', isDark ? 'text-secondary-light' : 'text-primary-main sm:bg-primary-lighter-12', classNames),
      "aria-hidden": true,
      children: /*#__PURE__*/_jsx("div", {
        style: {
          transform: 'rotate(45deg)'
        },
        className: "tw-w-2 tw-h-2",
        children: _ArrowUp || (_ArrowUp = /*#__PURE__*/_jsx(ArrowUp, {
          className: "tw-fill-current",
          size: 20
        }))
      })
    });
  }, [isDark]);
  return /*#__PURE__*/_jsx(Tooltip, {
    label: metric.tooltipLabel || metric.description,
    isDark: isDark,
    children: /*#__PURE__*/_jsxs("button", {
      type: "button",
      className: cn('tw-relative tw-rounded-0.4',
      // Sizes
      'tw-w-full md:tw-h-11.2',
      // Text
      'tw-text-left',
      // Padding
      'tw-p-1.2 lg:tw-p-0.8',
      // Flex
      'md:tw-flex md:tw-flex-col md:tw-justify-between',
      // Shadow
      'tw-shadow-01 hover:tw-shadow-04 dark:tw-shadow-none',
      // Background color
      'dark:tw-bg-neutral-dark-700',
      // Transition
      'tw-transition-shadow', className),
      "aria-label": "".concat(metric.description, " ").concat(metric.inProgress, "/").concat(metric.total),
      onClick: metric.onClick,
      children: [isMd && renderArrow('tw-mb-0.4'), /*#__PURE__*/_jsxs("div", {
        className: "tw-flex tw-justify-between tw-items-center tw-full",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "tw-flex tw-flex-row tw-items-center sm:tw-items-start lg:tw-flex-col",
          children: [/*#__PURE__*/_jsxs("div", {
            className: cn('lg:tw-mb-0.4 tw-mr-0.8 lg:tw-mr-0 font-subtitle2 sm:font-subtitle3', isDark ? 'text-secondary-light' : 'text-primary-main'),
            children: [metric.inProgress, "/", metric.total]
          }), /*#__PURE__*/_jsx("p", {
            className: "font-subtitle4",
            children: metric.description
          })]
        }), !isMd && renderArrow()]
      })]
    })
  });
};
export default ActionButton;